import { TimelineUpdate } from '@groundfloor-platform/types-event-grid-events';
import { SubscriptionMatcher, SubscriptionCallback } from '../signalR.eventCentre';

export const TimelineUpdatesSignalRAttributeName = 'timeline' as const;

export const TimelineUpdateEventTopic = 'timeline-updates' as const;

export type TimelineUpdatesSubscriptionCallback = SubscriptionCallback<TimelineUpdate>;

export type TimelineUpdatesSubscriptionMatcher = SubscriptionMatcher<TimelineUpdate>;

export interface TimelineUpdatesSubscriptionStream extends Record<string, string[]> {
  deliveryIDs: string[];
  workflowIDs: string[];
  projectIDs: string[];
}
